import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonContent, IonFooter, useIonViewWillEnter } from '@ionic/react'
import { CouponItem, CouponDetail, MktEmpty, SendInfoModal, ContactType, TsxToHtml, Header } from '@cps'
import { modalLayer, useHistoryNew, toast } from '@utils'
import { memberMobx, storeMobx } from '@mobxStore'
import { format, getHandTopUrl } from '@dt/fe-utils'
import { each, cloneDeep, values, keyBy } from '@dt/fe-utils/dist/lodash'
import mktController from 'controllers/mktController'
import MemberApi from '@api/member.api'
import i18n from 'i18next'
import Temp from './temp'
import noCouponImg from '@img/no-coupon.png'
import './index.scss'

interface IProps { }

const CouponGivePage: FC<IProps> = (props: IProps) => {
  const history = useHistoryNew()
  const { couponList, giveCoupon, brandConfig } = memberMobx
  const [isChoose, setIsChoose] = useState<boolean>(false)
  const [coupons, setCoupons] = useState<any[]>([])
  const [allowCoupon, setAllowCoupon] = useState<any[]>([])
  const [notCoupon, setNotCoupon] = useState<any[]>([])
  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'use', couponInfo: data }, 'couponDetail')
  }
  const changeChoose = () => {
    if (isChoose) {
      setCoupons([])
    }
    setIsChoose(!isChoose)
  }
  const selectCoupon = (info: any) => {
    if (info.status === 'disable') return
    if (!isChoose) return
    const resultArr: any[] = cloneDeep(coupons)
    if (coupons.includes(info.memberCouponId)) {
      resultArr.splice(coupons.indexOf(info.memberCouponId), 1)
    } else {
      resultArr.push(info.memberCouponId)
    }
    setCoupons(resultArr)
  }
  const radioCoupon = (info: any) => {
    if (info.status === 'disable') return
    sendCoupon([info.memberCouponId])
  }
  const couponDiscount = (info: any) => {
    if (info.type === 'cash') {
      return i18n.t('mkt.coupon.cashDeductionDetail', { fee: format.toPrice(info.discountValue) })
    } else if (info.type === 'item') {
      if (info.discountType === 'discountFee') return i18n.t(`mkt.coupon.${info.discountType}ItemDetail`, { fee: format.toPrice(info.discountValue) })
      if (info.discountType === 'discountRate') return i18n.t(`mkt.coupon.${info.discountType}ItemDetail`, { fee: format.toDiscount('discountRate', info.discountValue) })
      if (info.discountType === 'specialOffer') return i18n.t(`mkt.coupon.${info.discountType}ItemDetail`, { fee: format.toPrice(info.discountValue) })
    } else if (info.type === 'order' || info.type === 'designate') {
      if (info.discountType === 'discountFee') return i18n.t(`mkt.coupon.${info.discountType}OrderDetail`, { orderFee: format.toPrice(info.orderFee), discountFee: format.toPrice(info.discountValue) })
      if (info.discountType === 'discountRate') return i18n.t(`mkt.coupon.${info.discountType}OrderDetail`, { orderFee: format.toPrice(info.orderFee), discountFee: format.toDiscount('discountRate', info.discountValue) })
    } else if (info.type === 'ladder') {
      return i18n.t('mkt.coupon.discountFeeItem')
    } else {
      return ''
    }
  }
  const giveCouponInfo = (ids: any[]) => {
    const resultCoupons: any = {}
    const couponMap = keyBy(couponList, 'memberCouponId')
    each(ids, (item: any) => {
      const obj = couponMap[item]
      if (obj) {
        const key: string = `${obj.couponId}_${obj.startTime}_${obj.endTime}`
        if (resultCoupons[key]) {
          resultCoupons[key].count += 1
        } else {
          resultCoupons[key] = {
            ...obj,
            count: 1,
            discountTitle: couponDiscount(obj)
          }
        }
      }
    })
    return values(resultCoupons)
  }
  const sendCoupon = (coupon?: any[]) => {
    const ids = coupon || coupons
    modalLayer(ContactType, { hasThird: true }).then((type: any) => {
      const cps = couponList.filter(item => ids.includes(item.memberCouponId))
      const couponInfo = cps.filter(item => item.picture)[0] || cps[0]
      if (type === 'wechatMini') {
        const shareInfo = {
          mode: 'coupon',
          ids: ids,
          shareInfo: {
            title: couponInfo.couponName,
            imageUrl: brandConfig.shareImg || couponInfo.picture || '',
            desc: couponDiscount(couponInfo)
          }
        }
        mktController.jumpMiniGive(shareInfo, `${location.origin}/iCoupon?ct=brand&b=${Config.BRANDID}`)
      } else {
        const sendInfo: any = {
          type: 'coupon',
          title: couponInfo.couponName,
          img: couponInfo.picture || '',
          cnt: ids.length,
          desc: couponDiscount(couponInfo)
        }
        modalLayer(SendInfoModal, { type, title: i18n.t('mkt.coupon.giveInfo'), sendInfo, sendMessage: i18n.t('mkt.giftCard.tipBuyRemark2') }).then((val: any) => {
          const para: any = {
            memberCouponIds: ids,
            giverName: ['wechat', 'wechatMini'].includes(type) ? memberMobx.memberInfo.nickName : val.givePerson,
            receiverName: ['wechat', 'wechatMini'].includes(type) ? '' : val.receivedPerson,
            message: val.message,
          }
          if (type === 'email') {
            para.receiverEmail = val.user
            para.noSendEmail = true
          } else if (type === 'mobile') {
            para.receiverMobile = val.user
            para.countryCode = val.countryCode
          }
          giveCoupon(para).then((res: any) => {
            if (res) {
              if (type === 'wechat') {
                const url: string = `${getHandTopUrl()}/mmg/#/coupon/${res.memberCouponGiveId}?ct=brand&b=${storeMobx.brand.brandId}`
                mktController.jumpMmgUrl(url, i18n.t('mkt.member.sendCouponText', { name: memberMobx.memberInfo.nickName }))
              }
              if (type === 'email') {
                const data = {
                  coupons: giveCouponInfo(ids),
                  cnt: ids.length,
                  giverName: para.giverName,
                  receiverName: para.receiverName,
                  message: para.message,
                  url: `${getHandTopUrl()}/mmg/#/coupon/${res.memberCouponGiveId}?ct=brand&b=${storeMobx.brand.brandId}`
                }
                const str = TsxToHtml(<Temp data={data}></Temp>)
                sendEmail({ nickName: para.giverName, to: para.receiverEmail, html: str })
              }
              toast({ message: i18n.t('mkt.common.giveSucc') })
              setCoupons([])
              setIsChoose(false)
            }
          })
        })
      }
    })
  }
  const sendEmail = (data: any) => {
    MemberApi.sendEmail({
      nickName: data.nickName,
      to: data.to,
      subject: i18n.t('pageName.coupon'),
      html: data.html
    }).then(() => {
      // toast({ message: i18n.t('mkt.common.giveSucc') })
    })
  }
  // Component Effect
  useIonViewWillEnter(() => {
    setCoupons([])
  })
  useEffect(() => {
    const allowArr: any[] = []
    const notArr: any[] = []
    each(couponList, (item: any) => {
      if (item.isGive && item.status === 'enable') {
        allowArr.push(item)
      } else {
        notArr.push(item)
      }
    })
    setAllowCoupon(allowArr)
    setNotCoupon(notArr)
  }, [couponList])
  return (
    <IonPage className='my-coupon-give-page'>
      <Header title={`${i18n.t('mkt.coupon.couponGive')} (${allowCoupon.length})`} onBack={() => history.goBack()}></Header>
      <IonContent className='page-content'>
        <div className='page-body'>
          {allowCoupon.length > 0 &&
            <div className='coupon-give-choose'>
              <span data-cypid='mmgMultipleChooseCoupon' onClick={changeChoose}>{isChoose ? i18n.t('common.cancel') : i18n.t('mkt.coupon.multipleChoice')}</span>
            </div>}
          {couponList.length === 0 && <MktEmpty img={noCouponImg} />}
          {
            couponList.length > 0 &&
              <>
                {
                  allowCoupon.length > 0 &&
                    <div className='coupon-area'>
                      {
                        allowCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              {
                                isChoose
                                  ? <CouponItem type='use' selected={coupons.includes(item.memberCouponId)} couponInfo={item} onDetail={goDetail} onClick={selectCoupon}></CouponItem>
                                  : <CouponItem type='use' couponInfo={item} onDetail={goDetail} onClick={radioCoupon}></CouponItem>
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                }
                {
                  notCoupon.length > 0 &&
                    <div className='coupon-area'>
                      <div className='area-title'>{i18n.t('mkt.coupon.availableCoupons')}</div>
                      {
                        notCoupon.map((item: any) => {
                          return (
                            <div className='coupon-block' key={item.memberCouponId}>
                              <CouponItem type='use' unavailable unavailableReason={i18n.t('mkt.coupon.notTrans')} couponInfo={item} onDetail={goDetail}></CouponItem>
                            </div>
                          )
                        })
                      }
                    </div>
                }
              </>
          }
        </div>
      </IonContent>
      <IonFooter className='page-footer'>
        {
          coupons.length > 0
            ? (
              <div className='send-area'>
                <span>{i18n.t('cart.counponLength', { count: coupons.length })}</span>
                <div className='send-btn' onClick={() => sendCoupon()}>
                  <span>{i18n.t('mkt.coupon.goCoupon')}</span>
                </div>
              </div>
            ) : <>{!isChoose && <div data-cypid='mmgToCouponRecord' className='send-record' onClick={() => history.push('/iCoupon/giftRecord')}>{i18n.t('mkt.giftCard.transferRecord')}</div>}</>
        }
      </IonFooter>
    </IonPage>
  )
}

export default observer(CouponGivePage)
